<template>
  <div class="card" @click="showModal = true">
    <div class="card-header">
      <i class="bi bi-folder2-open"></i>
      <i class="bi bi-eye"></i>
    </div>
    <div class="card-body">
      <div class="card-title">{{ project.title }}</div>
      <p class="card-text">
        {{ project.preview }}
      </p>
    </div>
    <div class="card-footer">
      <p>
        <span v-for="item in project.stack" :key="item" class="stack-item">
          {{ item }}</span
        >
      </p>
      <p>{{ project.year }}</p>
    </div>
  </div>
  <div class="modal-wrapper" :class="{ visible: showModal }">
    <div class="modal-body">
      <div class="modal-header">
        <h3 class="txt-primary mb-4">{{ project.title }}</h3>
        <a
          role="button"
          class="close"
          aria-label="Close"
          @click="showModal = false"
        >
          <i class="bi bi-x"></i>
        </a>
      </div>
      <div class="row">
        <div class="col-12 col-xl-6 img-col">
          <img
            :src="project.thumbnail"
            :alt="project.title"
            class="img-fluid mb-4"
          />
        </div>
        <div class="col-12 col-xl-6 txt-col">
          <p v-for="feat in project.featured" :key="feat">
            {{ feat }}
          </p>
          <p class="modal-date">Date: {{ project.date }}</p>
        </div>
      </div>
      <div class="btn-center mb-4 project-links">
        <template v-for="button in project.preview_buttons" :key="button.link">
          <a
            target="_blank"
            class="mx-2"
            v-if="button.type === 'external'"
            :href="button.link"
          >
            {{ button.text }}
          </a>
          <router-link
            v-else
            :to="{ name: 'ProjectDetails', params: { id: button.link } }"
          >
            {{ button.text }}
          </router-link>
        </template>
      </div>
    </div>
    <span class="outside-trigger" @click="showModal = false"></span>
  </div>
</template>

<script>
export default {
  name: 'ProjectCard',
  props: ['project', 'index'],
  data() {
    return {
      showModal: false,
    };
  },
};
</script>
